<template>
  <div>
    <!-- <van-sticky>
      <van-nav-bar title="订单详情" left-arrow @click-left="onClickLeft" />
    </van-sticky> -->
    <!--pages/order-detail/order-detail.wxml-->

    <div class="container">
      <!-- 地址 -->
      <div class="order-detail">
        <div class="delivery-addr">
          <div class="user-info">
            <span class="item">{{ userAddrDto.receiver }}</span>
            <span class="item">{{ userAddrDto.mobile }}</span>
          </div>
          <div class="addr">
            {{ userAddrDto.province }}{{ userAddrDto.city }}{{ userAddrDto.area
            }}{{ userAddrDto.area }}{{ userAddrDto.addr }}
          </div>
        </div>

        <!-- 商品信息 -->
        <div class="prod-item">
          <div class="order-num">
            <div class="order-state">
              <span class="order-sts gray">{{
                [
                  "",
                  "待支付",
                  "待发货",
                  "待收货",
                  "已完成",
                  "已完成",
                  "已取消",
                  "拼团中",
                ][status]
              }}</span>
            </div>
          </div>
          <div v-for="(item, index) in orderItemDtos" :key="index">
            <div class="item-cont" bindtap="toProdPage">
              <div class="prod-pic">
                <img :src="item.pic" />
              </div>
              <div class="spell-group-icon" v-if="orderType > 1">
                <span class="group-span">{{
                  ["", "拼团", "秒杀", "积分"][orderType]
                }}</span>
              </div>
              <div class="prod-info">
                <div class="prodname">
                  {{ item.prodName }}
                </div>
                <div class="prod-info-cont">
                  <span class="number">数量：{{ item.prodCount }}</span>
                  <span class="info-item">{{ item.skuName }}</span>
                  <span class="info-items" v-if="item.status != -1"
                    >已发货</span
                  >
                  <span class="info-items" v-if="item.status != 0">待发货</span>
                </div>
                <div class="price-nums clearfix">
                  <span class="prodprice"
                    ><span class="symbol" v-if="item.price">
                      <img v-if="activityId === 9 || activityId === 13" src="https://img.zhujiaxian.com/2025/09/c5cc377d7c4c44f489ddc1130c867d08.png" style="width:12px; height:12px; vertical-align: middle;">
                      <span v-else>￥</span>
                    </span>
                    <span class="big-num" v-if="item.price">{{
                      item.price.toFixed(2)
                    }}</span>
                    <span class="small-num" v-if="item.price && item.useScore"
                      >&ensp;+&ensp;</span
                    >
                    <span class="big-num" v-if="item.useScore"
                      >{{ item.useScore }} 积分</span
                    ></span
                  >
                </div>
              </div>
              <span class="apply-refund-btns" v-if="item.status != -1"
              @click="toDeliveryPage(orderNumber)"
                >查看物流</span
              >
              <!-- <span
                class="apply-refund-btn"
                v-if="!item.refundSn && canRefund && orderType != 3"
                @click="applyRefunds(2,orderNumber,item)"
                >申请退款</span
              > -->
              <span class="apply-refund-btn" v-if="item.refundSn"
                @click="toafterSales"
                >查看退款</span
              >
            </div>
            <div class="prod-foot">
            <div class="btn">
              <button v-if="item.status == 1" class="button">取消订单</button>
              <button v-if="item.status == 1" class="button warn">付款</button>
              <button
                v-if="item.status == 3 || item.status == 5"
                class="button"
              >
                查看物流
              </button>
              <button v-if="item.status == 3" class="button warn">
                确认收货
              </button>
            </div>
          </div>
          </div>
          
        </div>

        <!-- 订单信息 -->
        <div class="order-msg">
          <div class="msg-item">
            <div class="item">
              <span class="item-tit">订单编号：</span>
              <span class="item-txt">{{ orderNumber }}</span>
              <span class="copy-btn">复制</span>
            </div>
            <div class="item">
              <span class="item-tit">下单时间：</span>
              <span class="item-txt">{{ createTime }}</span>
            </div>
          </div>
          <div class="msg-item">
            <div class="item">
              <span class="item-tit">支付方式：</span>
              <span class="item-txt" v-if="payType == 1">微信支付</span>
              <span class="item-txt" v-if="payType == 9">余额支付</span>
              <span class="item-txt" v-if="payType == 10">组合支付</span>
            </div>
            <div class="item">
              <span class="item-tit">配送方式：</span>
              <span class="item-txt">普通配送</span>
            </div>
            <div class="item">
              <span class="item-tit">订单备注：</span>
              <span class="item-txt">{{ remarks ? remarks : "" }}</span>
            </div>
          </div>
        </div>

        <div class="order-msg" style="padding-bottom: 80px;">
          <div class="msg-item">
            <div class="item">
              <div class="item-tit">订单总额：</div>
              <div class="item-txt price">
                <span class="symbol">
                  <img v-if="activityId === 9 || activityId === 13" src="https://img.zhujiaxian.com/2025/09/c5cc377d7c4c44f489ddc1130c867d08.png" style="width:12px; height:12px; vertical-align: middle;">
                  <span v-else>￥</span>
                </span>
                <span class="big-num">{{ productTotalAmount.toFixed(2) }}</span>
              </div>
            </div>
            <div class="item">
              <div class="item-tit">运费：</div>
              <div class="item-txt price">
                <span class="symbol">
                  <img v-if="activityId === 9 || activityId === 13" src="https://img.zhujiaxian.com/2025/09/c5cc377d7c4c44f489ddc1130c867d08.png" style="width:12px; height:12px; vertical-align: middle;">
                  <span v-else>￥</span>
                </span>
                <span class="big-num">{{ transfee.toFixed(2) }}</span>
              </div>
            </div>
            <div class="item">
              <div class="item-tit">总优惠金额：</div>
              <div class="item-txt price">
                <span class="symbol">-<img v-if="activityId === 9 || activityId === 13" src="https://img.zhujiaxian.com/2025/09/c5cc377d7c4c44f489ddc1130c867d08.png" style="width:12px; height:12px; vertical-align: middle;"><span v-else>￥</span></span>
                <span class="big-num">{{ reduceAmount.toFixed(2) }}</span>
              </div>
            </div>
            <div class="item" v-if="payType == 10">
              <div class="item-tit">余额：</div>
              <div class="item-txt price">
                <span class="symbol">-<img v-if="activityId === 9 || activityId === 13" src="https://img.zhujiaxian.com/2025/09/c5cc377d7c4c44f489ddc1130c867d08.png" style="width:12px; height:12px; vertical-align: middle;"><span v-else>￥</span></span>
                <span class="big-num">{{ balance.toFixed(2) }}</span>
              </div>
            </div>
            <!-- <div class="item coupon member-points" v-if="totalUsableScore > 0">
              <div class="integral-wrap">
                <div class="integral-deduction">
                  可用{{ totalUsableScore }}积分抵扣{{ totalScoreAmount }}元
                </div>
              </div>
            </div> -->
            <div class="item payment">
              <div
                class="item-txt price"
                v-if="(status < 6 && status != 1) || status == 7"
              >
                订单总额：
                <span class="symbol" v-if="actualTotal || actualTotal == 0">
                  <img v-if="activityId === 9 || activityId === 13" src="https://img.zhujiaxian.com/2025/09/c5cc377d7c4c44f489ddc1130c867d08.png" style="width:12px; height:12px; vertical-align: middle;">
                  <span v-else>￥</span>
                </span>
                <span class="big-num" v-if="actualTotal || actualTotal == 0">{{
                  actualTotal.toFixed(2)
                }}</span>
                <span class="small-num" v-if="actualTotal && orderType == 3"
                  >&ensp;+&ensp;</span
                >
                <span class="big-num" v-if="orderType == 3"
                  >{{ orderItemDtos[0].useScore }} 积分</span
                >
              </div>
              <div class="item-txt price" v-if="status == 6 || status == 1">
                实际总额：
                <span class="symbol" v-if="actualTotal">
                  <img v-if="activityId === 9 || activityId === 13" src="https://img.zhujiaxian.com/2025/09/c5cc377d7c4c44f489ddc1130c867d08.png" style="width:12px; height:12px; vertical-align: middle;">
                  <span v-else>￥</span>
                </span>
                <span class="big-num" v-if="actualTotal">{{
                  actualTotal.toFixed(2)
                }}</span>
                <span class="small-num" v-if="actualTotal && orderType == 3"
                  >&ensp;+&ensp;</span
                >
                <span class="big-num" v-if="orderType == 3"
                  >{{ orderItemDtos[0].useScore }} 积分</span
                >
              </div>
            </div>
          </div>
        </div>

        <div class="order-detail-footer">
          <div class="footer-box">
            <span
              class="apply-refund-btn refund-full"
              v-if="canAllRefund && orderType != 3"
              @click="applyRefunds(1,orderNumber)"
              >整单退款</span
            >
            <button class="apply-service foot-btn">联系客服</button>
            <button class="apply-service foot-btn" v-if="orderType == 1">
              查看团购详情
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { GetorderDetail } from "@/https/http";
export default {
  data() {
    return {
      userMobile: "",
      ordermobile: [],
      orderItemDtos: [],
      remarks: "",
      balance: 0,
      actualTotal: 0,
      userAddrDto: {},
      orderNumber: "",
      createTime: "",
      status: 0,
      productTotalAmount: "",
      transfee: "",
      reduceAmount: "",
      // actualTotal: "",
      prodid: "",
      payType: 1,
      orderType: 0,
      canRefund: false, // 能否退款
      canAllRefund: false, // 能否整单退款
      isLastProd: false, //最后一款商品
      irrevocable: false, //不可撤销
      refundState: null,
      sum: [], //本单已申请单个退款的商品数组
      totalNum:null,
      // activityId:9
    };
  },
  created() {
    let oNumber = this.$route.params.orderNumber;
    this.loadOrderDetail(oNumber);
    
    // 获取退款返回数据
    const refundBackData = localStorage.getItem('refundBackData');
    if (refundBackData) {
      const data = JSON.parse(refundBackData);
      // 使用返回的数据重新加载订单详情
      if (oNumber === undefined) {
        this.loadOrderDetail(data.orderNumber);
       }
      // 清除数据
      localStorage.removeItem('refundBackData');
    }
  },
//   mounted(){
//     this.loadOrderDetail(orderNumber);
//   },
  methods: {
    toDeliveryPage(orderNumber){
      console.log(orderNumber,'orderNumber');
      this.$router.push({ name: "logisticsInfo",params:{ orderNumber} });
    },
    applyRefunds(e,orderNumber,item){
      console.log(item,'item');
      
      if(e == 1){ //整单退款
        //window.localStorage.setItem("openID", result.data.openid);.
        this.$router.push({ path: "/applyRefund",query:{ refundType:e,orderNumber:orderNumber} });
      }else{
        console.log(item,'item2');
        
        window.localStorage.setItem("refundItem", JSON.stringify(item));
        this.$router.push({ path: "/applyRefund",query:{ refundType:e,orderNumber:orderNumber} });
      }
    },
    toafterSales(){
      this.$router.push({ path: "/afterSales"});
    },
    onClickLeft() {
            this.$router.go(-1);
        },
    loadOrderDetail(oNumber) {
        
        GetorderDetail(oNumber).then((res) => {
        console.log(res);
        let ress = res.data;
        console.log(ress);
        this.userAddrDto = ress.userAddrDto;
        this.orderNumber = oNumber;
        this.balance = ress.balance;
        this.payType = ress.payType;
        this.actualTotal = ress.actualTotal; //实际支付总额（商品总额+运费)
        this.remarks = ress.remarks;
        this.orderItemDtos = ress.orderItemDtos;
        this.totalNum = ress.totalNum;
        this.createTime = ress.createTime;
        this.status = ress.status;
        this.productTotalAmount = ress.total; //所有商品总额
        this.transfee = ress.transfee; //运费
        this.reduceAmount = ress.reduceAmount;
        this.orderType = ress.orderType;
        this.shopName = ress.shopName;
        this.canRefund = ress.canRefund;
        this.canAllRefund = ress.canAllRefund;
      });
    },
  },
};
</script>
<style lang="less">
/* pages/order-detail/order-detail.wxss */
img {
  width: 100%;
  height: 100%;
}
page {
  background: #f4f4f4;
}
.display {
  display: none !important;
}

/* 头部流程-等待商家发货 */
.process {
  padding: 10px;
  font-size: 14px;
  border-bottom: 1px solid #f2f2f2;
  background: #fff;
}
.process-top {
  padding: 10px 0;
  margin-top: 5px;
}
.shop-icon {
  width: 35px;
  height: 35px;
  margin-right: 7px;
  vertical-align: middle;
}
.wait {
  vertical-align: middle;
}
/* 进程 */
.process-list {
  position: relative;
  padding-top: 15px;
  padding-bottom: 7px;
  display: flex;
  justify-content: space-between;
}
.process-item {
  font-size: 13px;
  color: #aaa;
  text-align: center;
}
.buyers-pay {
  text-align: left;
}
.successful {
  text-align: right;
}
.current-txt {
  color: #17b606;
}
.item-icon {
  width: 10px;
  height: 10px;
}
.solid-round {
  display: inline-block;
  width: 6px;
  height: 6px;
  background: #bbb;
  border-radius: 50%;
}
/* 进度条 */
.line {
  position: absolute;
  bottom: 14px;
  height: 1.5px;
  background: #f0f0f0;
}
.line-current {
  background: #46b229;
}
.line01 {
  left: 17px;
  width: 42%;
}
.line02 {
  right: 17px;
  width: 42%;
}
.spell-line01 {
  width: 25%;
  left: 17px;
}
.spell-line02 {
  width: 25%;
  left: 123px;
}
.spell-line03 {
  width: 25%;
  right: 16px;
}

/*  地址  */
.order-detail {
  margin-bottom: 60px;
  font-size: 15px;
}
.order-detail .delivery-addr {
  padding: 10px 15px;
  background: #fff;
}
.order-detail .delivery-addr .user-info {
  line-height: 24px;
  word-wrap: break-word;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.order-detail .delivery-addr .user-info .item {
  font-size: 14px;
  margin-right: 15px;
  vertical-align: top;
  display: inline-block;
}
.order-detail .delivery-addr .addr {
  font-size: 13px;
  line-height: 18px;
  color: #999;
}

/* 商品列表 */
.prod-item {
  background-color: #fff;
  margin-top: 7px;
  font-size: 14px;
}
/* 拼团icon */
/* 单个商品 */
.group-text {
  font-size: 12px;
  color: #fff;
  background: #fe4443;
  padding: 2px 5px;
  border-radius: 4px;
  position: absolute;
  top: 20px;
  left: 20px;
}

.prod-item .item-cont .prod-pic img {
  width: 90px;
  height: 90px;
}
.prod-item .item-cont {
  position: relative;
  display: flex;
  align-items: center;
  padding: 15px;
  border-top: 1px solid #f1f1f1;
}
.prod-item .item-cont .prod-pic {
  font-size: 0;
  display: block;
  width: 80px;
  height: 80px;
  overflow: hidden;
  background: #fff;
  margin-right: 8px;
}
.prod-item .item-cont .prod-pic img {
  width: 100%;
  height: 100%;
}
.prod-item .item-cont .prod-info {
  margin-left: 5px;
  font-size: 14px;
  width: 100%;
  position: relative;
  height: 80px;
  -webkit-flex: 1;
  -ms-flex: 1;
  -webkit-box-flex: 1;
  -moz-box-flex: 1;
  flex: 1;
}
/* 申请退款按钮 */
.apply-refund-btn {
  position: absolute;
  right: 10px;
  bottom: 13px;
  font-size: 12px;
  padding: 3px 7px;
  color: #e43130;
  border: 1px solid #e43130;
  border-radius: 10px;
}
.apply-refund-btns {
  position: absolute;
  right: 75px;
  bottom: 12px;
  font-size: 12px;
  padding: 3px 7px;
  color: #e43130;
  border: 1px solid #e43130;
  border-radius: 10px;
}
.prod-item .item-cont .prod-info .prodname {
  font-size: 14px;
  line-height: 20px;
  max-height: 43px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  word-break: break-all;
}
.prod-item .item-cont .prod-info .prod-info-cont {
  position: relative;
  color: #999;
  /* margin-top: 10rpx; */
  font-size: 12px;
}
.prod-item .item-cont .prod-info .prod-info-cont .info-items {
  color: #999;
  height: 14px;
  margin-top: 5px;
  font-size: 12px;
  position: absolute;
  right: -34px;
  /* display: l; */
  /* text-align: revert; */
  /* overflow: hidden; */
  /* -webkit-line-clamp: 1; */
  /* -webkit-box-orient: vertical; */
  /* text-overflow: ellipsis; */
  /* word-break: break-all; */

  width: 70px;
  top: -7px;
}
.prod-item .item-cont .prod-info .prod-info-cont .info-item {
  color: #999;
  height: 14px;
  margin-top: 5px;
  font-size: 12px;

  /* display: -webkit-box; */
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  word-break: break-all;
  width: 70%;

  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  word-break: break-all;
}
.prod-item .item-cont .prod-info .prod-info-cont .number {
  float: left;
  margin-right: 10px;
}
.prod-item .price-nums {
  margin-top: 15px;
}
.prod-item .price-nums .prodprice {
  color: #333;
  height: 25px;
  line-height: 25px;
  font-size: 12px;
  left: 0;
  position: absolute;
  margin-top: 14px;
}
.prod-item .price-nums .btn-box {
  float: right;
  text-align: right;
}
.prod-item .price-nums .btn-box .btn {
  padding: 3px 15px;
  line-height: 18px;
  margin-left: 10px;
  font-size: 12px;
  display: inline-block;
  border: 1px solid #e4e4e4;
  border-radius: 25px;
}

/* 
订单信息 */

.order-msg {
  background: #fff;
  margin-top: 7px;
  font-size: 24px;
}

.order-msg .msg-item {
  padding: 10px;
  font-size: 14px;
  border-top: 1px solid #f1f1f1;
}

.order-msg .msg-item:first-child {
  border: 0;
}

.order-msg .msg-item .item {
  display: flex;
  padding: 5px 0;
  align-items: center;
}

.order-msg .msg-item .item.payment {
  border-top: 1px solid #f1f1f1;
  color: #e43130;
  padding-top: 15px;
}

.order-msg .msg-item .item .item-tit {
  color: #999;
  line-height: 24px;
}

.order-msg .msg-item .item .item-txt {
  flex: 1;
  line-height: 24px;
}

.order-msg .msg-item .item .copy-btn {
  display: block;
  margin-left: 10px;
  border: 1px solid #e4e4e4;
  padding: 3px 12px;
  border-radius: 50px;
  font-size: 12px;
  line-height: 14px;
}

.order-msg .msg-item .item .item-txt.price {
  text-align: right;
}

/* 底部栏 */
.order-detail-footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  max-width: 375px;
  background: #fff;
  margin: auto;
  display: -webkit-flex;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  padding: 11px 0;
  font-size: 13px;
  box-shadow: 0 -1px 3px rgba(0, 0, 0, 0.05);
}
.order-detail-footer .dele-order {
  margin-left: 10px;
  line-height: 30px;
  display: block;
  margin-right: 10px;
  width: 75px;
  text-align: center;
}
.order-detail-footer .footer-box {
  flex: 1;
  text-align: right;
  line-height: 30px;
}
.order-detail-footer .footer-box .buy-again {
  font-size: 13px;
  color: #fff;
  background: #e43130;
  border-radius: 25px;
  padding: 5px 10px;
  margin-right: 10px;
}
.order-detail-footer .footer-box .apply-service {
  display: inline-block;
  font-size: 13px;
  border-radius: 25px;
  border: 1px solid #e4e4e4;
  margin-right: 10px;
  background: #fff;
  color: #555;
  line-height: 1em;
  padding: 7px 13px;
  vertical-align: middle;
}
.order-detail-footer .footer-box .apply-service::after {
  border: 0;
}
.clearfix:after {
  content: " ";
  display: table;
  clear: both;
}
/* 底部整单退款 */
.refund-full {
  position: relative;
  bottom: 0;
  font-size: 13px;
  padding: 6px 13px;
  border-radius: 25px;
}

/* 根据状态显示不同的颜色 */

.order-state {
  height: 35px;
  line-height: 35px;
  text-align: right;
  margin-right: 10px;
}

.order-state .order-sts {
  color: #e43130;
  font-size: 14px;
}

.order-state .order-sts.gray {
  color: #999;
  height: 16px;
  line-height: 16px;
}

.order-state .order-sts.normal {
  color: #333;
}
</style>
